export default {
  name: "catchContent"
}



// WEBPACK FOOTER //
// ./src/layout/catchContent/catchContent.js